function isButton(value) {
  return value.component === "button";
}
function isLink(value) {
  return value.component === "a";
}
export {
  isButton,
  isLink
};
